import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import { TextDomain } from '../constants/TextDomain';
import { Alcohol } from '../models/Alcohol';
import './AlcoholItem.css';
import NutritionsTable from './NutritionsTable';

interface AlcoholItemProps {
    item: Alcohol;
}

const { __ } = window.wp.i18n;

const AlcoholItem: React.FC<AlcoholItemProps> = React.memo((props) => {
    const { item } = props;

    const [contentExpanded, setContentExpanded] = useState<boolean>(false);
    const contentRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (contentRef.current) {
            contentRef.current.style.display = 'none';
        }
    }, []);

    useEffect(() => {
        if (contentRef.current) {
            if (contentExpanded) {
                $(contentRef.current).show('slow');
            } else {
                $(contentRef.current).hide('slow');
            }
        }
    }, [contentExpanded]);

    return (
        <div id={item.id} className={`nutrition_value_item ${contentExpanded ? 'nutrition_value_item_expanded' : ''}`}>
            {~~item.alcohol_free === 1 && <div className="small-text alcfree_badge">Nealko</div>}
            <div className="nutrition_value_item_image_wrap">
                {item.image_id && (
                    <div className="nutrition_value_image" id="nutrition_value_image" style={{ backgroundImage: `url(${item.image_url})` }}></div>
                )}
            </div>
            <div className="nutrition_value_content">
                <div className="nutrition_value_header">
                    <h3 className="nutrition_value_name">{item.name}</h3>
                    <div hidden={contentExpanded} className="nutrition_value_info_row small-text">
                        <span style={{ fontWeight: 700 }}>
                            {item.energy_value_kj}kJ / {item.energy_value_kcal}kcal
                        </span>
                        <span> na 100ml</span>
                    </div>
                </div>
                <div ref={contentRef} className="nutrition_value_table_wraper">
                    <NutritionsTable item={item} />
                    {item.ingredients && (
                        <div className="nutrition_value_ingredients">
                            <div style={{ fontSize: 'small', fontWeight: 'bold' }}>{__('Ingredients', TextDomain)}</div>
                            <div>{item.ingredients}</div>
                        </div>
                    )}

                    {item.note && (
                        <div className="nutrition_value_note">
                            <div style={{ fontSize: 'small', fontWeight: 'bold' }}>{__('Note', TextDomain)}</div>
                            <div>{item.note}</div>
                        </div>
                    )}
                </div>
                <div className="all_nutrition_values_button">
                    <a className="small-text" onClick={() => setContentExpanded(!contentExpanded)}>
                        {__(contentExpanded ? 'Close table' : 'All nutrition values', TextDomain)}
                    </a>
                </div>
            </div>
        </div>
    );
});

export default AlcoholItem;
